import Sortable from 'sortablejs';

function refreshTackboardPreview() {
  var frame = document.getElementById('tackboard-preview');
  if (!frame) { return; }
  var params = new URLSearchParams();
  ($('#tackboard_include_tags').val() || []).forEach(function(tag) { params.append('include_tags[]', tag); });
  ($('#tackboard_exclude_tags').val() || []).forEach(function(tag) { params.append('exclude_tags[]', tag); });
  frame.src = frame.dataset.previewUrl + '?' + params.toString();
}

$(document).on('turbo:load', function() {

  new MediaAssetAction().bindTagInputs('#new_media_request .tagsinput', '#new_media_request .tagsinput-overlay');

  new MediaAssetAction().bindTagInputs('.tackboard-form .tagsinput', '.tackboard-form .tagsinput-overlay');

  $('.tackboard-form input[name="tackboard[board_type]"]').on('change', function() {
    var dynamic = this.value === 'dynamic';
    $('.tackboard-tag-rules').toggle(dynamic);
    if (dynamic) { refreshTackboardPreview(); }
  });

  $('.tackboard-form .tagsinput').on('tokenize:change', refreshTackboardPreview);

  $('.tackboard-posts.sortable').each(function(){
    Sortable.create($(this)[0], {
      filter: '.unsortable',
      onStart: function () {
        // Save order before sort
        this._currentOrder = this.toArray();
      },
      onUpdate: function (evt) {
        evt.preventDefault();
        // Disabling sorting
        this.option('disabled', true);
        this.el.classList.add('updating');

        setTimeout(function () {
          var form = $(this.el).parent().find('.reorder-form');
          form.find('#tackboard_reorder_from').val(evt.oldIndex);
          form.find('#tackboard_reorder_to').val(evt.newIndex);
          form[0].requestSubmit();

          this.option('disabled', false);
          this.el.classList.remove('updating');
        }.bind(this), 200);
      }
    });
  });
});
